import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { serializeSortItem } from '@utils/utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-users/')({
  validateSearch: zodValidator(withDefaults(schema.USER_MANAGEMENT, { orderBy: [serializeSortItem({ property: 'email', isAsc: true })] })),
});
